import { Tab, TabList } from "@headlessui/react";
import { ChevronDownIcon } from '@heroicons/react/16/solid';
import React from "react";
import { classNames } from "../../helpers";

export default function TwTabs(props) {
  const { children, className = "", tabs = [], selectedTab = "" } = props
  const tabList = tabs.length > 0 ? tabs.filter((d) => d.name !== undefined).map((d) => {
    return {
      key: d.name.replace(/\s+/g, '-').toLowerCase(),
      ...d,
    }
  }) : []

  return (
    <div>
      {/* <div className="grid grid-cols-1 sm:hidden">
        <select
          defaultValue={selectedTab}
          aria-label="Select a tab"
          className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
          onChange={(e) => {
            props.setSelectedTab(e.target.value)

            // if (tab?.onClick) {
            //   tab.onClick(e)
            // }
          }}
        >
          {tabList.map((tab) => (
            <option key={tab.key} value={tab.key}>{tab.name}</option>
          ))}
        </select>
        <ChevronDownIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
        />
      </div> */}
      {/* <div className="hidden sm:block"> */}
      <div className="">
        <div className={classNames("border-gray-200", className)}>
          <TabList aria-label="Tabs" className="-mb-px flex space-x-8 overflow-x-auto">
            {tabList.map((tab) => (
              <Tab
                key={tab.key}
                // onClick={(e) => {
                //   // props.setSelectedTab(tab.key)
                //   // if (tab?.onClick) {
                //   //   tab.onClick(e)
                //   // }
                // }}
                aria-current={selectedTab === tab.key ? 'page' : undefined}
                className={classNames(
                  'truncate group flex [min-w-full] flex-none md:inline-flex items-center px-1 py-4 text-sm font-medium border-0 border-b-2 outline-0 focus-within:outline-0 focus-visible:outline-0',
                  selectedTab === tab.key
                    // ? 'border-brown-coffee text-brown-coffee'
                    ? 'border-indigo-bz text-indigo-bz'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                    props.noBorder && props.noBorder === true
                    ? '!border-transparent'
                    : '',
                )}
              >
                {tab.icon && (<tab.icon
                  aria-hidden="true"
                  className={classNames(
                    selectedTab === tab.key ? 'text-indigo-bz' : 'text-gray-400 group-hover:text-gray-500',
                    '-ml-0.5 mr-2 size-5',
                  )}
                />)}
                <span>{tab.name}</span>
              </Tab>
            ))}
          </TabList>
        </div>
      </div>
    </div>
  );
}
